/**
 * Procore pinhole sessions keep clipping outlines on the GPU path drag already
 * uses. Building CPU outlines can block the first plane creation for seconds on
 * large models, while subsequent dragging is smooth because it already uses the
 * GPU.
 *
 * GPU outlines often disappear for surfaces orthogonal to an orthographic
 * camera, so Procore ortho and every standalone session stay on the CPU path.
 * Outline object picking only reads the CPU buffers and is standalone-only;
 * see {@link clippingOutlineObjectsArePickable}.
 */
export function clippingOutlinesAreGpuComputed(
    isProcoreDesign: boolean,
    cameraKind: "pinhole" | "orthographic",
): boolean {
    return isProcoreDesign && cameraKind === "pinhole";
}

/**
 * Whether `view.getOutlineObjectsOnScreen()` can answer. It reads the CPU outline
 * buffers. Outline Laser is standalone-only, so Procore is never asked to pick
 * even when a Procore ortho session is on the CPU path. Callers check this
 * rather than treating the empty result as "nothing is clipped".
 */
export function clippingOutlineObjectsArePickable(isProcoreDesign: boolean): boolean {
    return !isProcoreDesign;
}

/**
 * Interiors of cut walls stay visible. `triangles.doubleSided` only disables
 * `CULL_FACE` on the same draw — it is not extra geometry and does not move the
 * primitive or GPU-byte budgets — so handhelds keep the desktop behaviour.
 */
export function clippingTrianglesAreDoubleSided(hasClippingPlanes: boolean): boolean {
    return hasClippingPlanes;
}
